export default __webpack_public_path__ + "static/media/beispiel-versicherungsausweis.9126e19e.png";